import aiServer from '@assets/images/solution/recommendation/mobile/aiServer.avif';
import co2 from '@assets/images/solution/recommendation/mobile/co2.avif';
import edgeRtls from '@assets/images/solution/recommendation/mobile/edgeRtls.avif';
import fisheye from '@assets/images/solution/recommendation/mobile/fisheye.avif';
import idCard from '@assets/images/solution/recommendation/mobile/idCard.avif';
import ipCamera from '@assets/images/solution/recommendation/mobile/ipCamera.avif';
import loraGateway from '@assets/images/solution/recommendation/mobile/loraGateway.avif';
import nvr from '@assets/images/solution/recommendation/mobile/nvr.avif';
import patientTag from '@assets/images/solution/recommendation/mobile/patientTag.avif';
import ptz from '@assets/images/solution/recommendation/mobile/ptz.avif';
import safeCradle from '@assets/images/solution/recommendation/mobile/safeCradle.avif';
import safeTag from '@assets/images/solution/recommendation/mobile/safeTag.avif';
import safetyBell from '@assets/images/solution/recommendation/mobile/safetyBell.avif';
import server from '@assets/images/solution/recommendation/mobile/server.avif';
import slimTag from '@assets/images/solution/recommendation/mobile/slimTag.avif';
import stickerTag from '@assets/images/solution/recommendation/mobile/stickerTag.avif';
import switchImg from '@assets/images/solution/recommendation/mobile/switch.avif';
import twintrackerUwb from '@assets/images/solution/recommendation/mobile/twintrackerUwb.avif';
import uwbTag from '@assets/images/solution/recommendation/mobile/uwbTag.avif';
import plutoconPro from '@assets/images/solution/recommendation/mobile/plutoconPro.avif';
import twintrackerBLE from '@assets/images/solution/recommendation/mobile/twintrackerBle.avif';

export default {
  ipCamera: {
    title: 'IPカメラ',
    desc: 'IPカメラは、インターネットプロトコルを利用して映像データをネットワーク経由で送信するデジタルCCTVです。設置が簡単で、遠隔監視や映像保存が可能なため、セキュリティ、安全、運用管理に広く利用されています。',
    img: ipCamera,
    link: '/camera/edge',
  },
  ptzCamera: {
    title: 'PTZカメラ',
    desc: 'PTZカメラは、パン・チルト・ズーム機能を備えた高性能CCTVで、パン（左右回転）、チルト（上下傾き）、ズーム（光学拡大）を遠隔制御可能なため、1台で広範囲を効率的に監視できます。',
    img: ptz,
    link: '/camera/edge',
  },
  fisheyeCamera: {
    title: '魚眼カメラ',
    desc: '魚眼カメラは180度以上の超広角レンズを使用し、1台で広い空間全体を撮影可能なCCTVです。歪みはあるものの、死角のない全方位監視が可能です。',
    img: fisheye,
    link: '/camera/edge',
  },
  co2: {
    title: 'CO₂センサー',
    desc: 'CO₂センサーは空気中の二酸化炭素濃度をリアルタイムで検出し、危険閾値に達すると警報音と視覚アラートで通知します。バッテリーまたは外部電源で作動し、現場の安全管理に不可欠な装置です。',
    img: co2,
    link: '/iot/co2',
  },
  server: {
    title: 'ORBROサーバー',
    desc: 'ORBROサーバーは、RTLS、CCTV、センサーなどの現場デバイスから収集されたデータを統合管理し、リアルタイム分析・レポート・通知機能を提供する中核的な中央サーバープラットフォームです。API連携にも対応します。',
    img: server,
    link: '/os/server',
  },
  aiServer: {
    title: 'ORBRO AIサーバー',
    desc: 'ORBRO AIサーバーは、現場で収集された映像や検知データをリアルタイムで分析し、異常を自動で検出して即時に通知・報告する、ネットワーク負荷の少ないインテリジェントエッジAI分析サーバーです。',
    img: aiServer,
    link: '/camera/server',
  },
  nvr: {
    title: 'NVR',
    desc: 'NVR（ネットワークビデオレコーダー）は、カメラから送られる映像をネットワーク経由で受信し、保存・管理を行う装置です。複数のカメラ映像を同時に録画・モニタリング・検索できる映像ストレージソリューションです。',
    img: nvr,
    link: '/camera/server',
  },
  twintrackerUWB: {
    title: 'TwinTracker UWB',
    desc: 'TwinTracker UWBは、UWB信号を受信して±10cm以内の高精度な位置を算出する超広帯域ベースの位置追跡リーダーです。複数のタグを同時に追跡し、複雑な空間でも安定したリアルタイム位置データを提供します。',
    img: twintrackerUwb,
    link: '/rtls/uwb',
  },
  twintrackerBLE: {
    title: 'TwinTracker BLE',
    desc: 'TwinTracker BLEは、BLE信号を検知してタグの位置をゾーン単位で把握する屋内用位置追跡リーダーです。設置・運用が容易で、多数の資産や人員の位置管理に適しています。',
    img: twintrackerBLE,
    link: '/rtls/uwb',
  },
  uwbTag: {
    title: 'UWBタグ',
    desc: 'UWBタグは、人や機器に取り付けて±10cm以内の精度でリアルタイムに位置を追跡できるタグです。耐衝撃・防水設計、低消費電力で長時間の使用が可能です。',
    img: uwbTag,
    link: '/rtls/uwb',
  },
  stickerTag: {
    title: 'ステッカータグ',
    desc: 'ステッカータグは資産に簡単に貼り付けられる超小型タグで、リアルタイムの位置追跡と移動履歴を収集します。軽量・低消費電力で、物流や製造現場に柔軟に対応します。',
    img: stickerTag,
    link: '/rtls/uwb',
  },
  slimTag: {
    title: 'スリムタグ',
    desc: 'スリムタグはBLEベースのカード型超薄型タグで、制服のポケットや資産表面に簡単に挿入・装着可能です。軽量・低消費電力設計で、人員や資産の室内位置管理に最適です。',
    img: slimTag,
    link: '/rtls/uwb',
  },
  edgeRtls: {
    title: 'ORBRO Edge RTLS',
    desc: 'ORBRO Edge RTLSは、現場で受信したタグ信号をリアルタイムで処理し、位置を算出するエッジ専用デバイスです。クラウドなしでも独立運用できる超低遅延の位置追跡装置です。',
    img: edgeRtls,
    link: '/os/rtls',
  },
  edgeAi: {
    title: 'ORBRO Edge AI',
    desc: 'ORBRO Edge AIは、タグ信号を現場でリアルタイム処理し、位置を算出するAIエッジデバイスです。クラウド接続不要で独立運用が可能な超低遅延設計です。',
    img: edgeRtls,
    link: '/os/rtls',
  },
  switch: {
    title: 'L2 PoEスイッチ',
    desc: 'L2 PoEスイッチは、ネットワークケーブル1本で電源供給とデータ通信の両方を処理可能な装置で、IPカメラ、UWBアンカー、BLEリーダーなど多様な現場機器を効率的に接続します。',
    img: switchImg,
    link: '/os/switch',
  },
  plutoconPro: {
    title: 'Plutocon Pro',
    desc: 'Plutocon Proは、BLEベースの強力な信号送信機能を備えた産業用ビーコンで、広範囲でも安定した位置認識が可能です。防水・防塵設計、バッテリー交換式構造で、物流・製造・資産管理に最適です。',
    img: plutoconPro,
    link: '/rtls/ble',
  },
  safeTag: {
    title: 'Safeタグ',
    desc: 'Safeタグはスマートフォンやタブレットなどの展示デバイスに取り付け、逸脱、分離、振動などの異常をリアルタイムで検知して通知する専用セキュリティタグです。',
    img: safeTag,
    link: '/os/rtls',
  },
  safetyBell: {
    title: 'セーフティベル',
    desc: 'セーフティベルは、緊急時に即座に警報と視覚・聴覚アラートを提供する安全補助装置です。システムと無線で連携し、現場全体の安全対応速度と効率を向上させます。',
    img: safetyBell,
    link: '/os/rtls',
  },
  safeCradle: {
    title: 'Safeクレードル',
    desc: 'Safeクレードルは、Safeタグと展示デバイスを固定する専用スタンドで、電源供給・無線通信・セキュリティ検知を安定的にサポートします。取り外し防止設計と精密なドッキング角度により、異常時には即座に通知されます。',
    img: safeCradle,
    link: '/os/rtls',
  },
  loraGateway: {
    title: 'LoRaゲートウェイ',
    desc: 'LoRaゲートウェイは、LoRaWANプロトコルに基づいた長距離通信対応のネットワークハブで、遠方のセンサーやタグからデータを安定して収集し、クラウドやエッジサーバーへ転送します。',
    img: loraGateway,
    link: '/os/rtls',
  },
  patientTag: {
    title: '患者用タグ',
    desc: '患者用タグは病院内で安全に装着できるUWB/BLEベースの医療向け位置追跡デバイスで、リアルタイム追跡とゾーン逸脱・緊急時の自動通知に対応し、迅速な対応を可能にします。',
    img: patientTag,
    link: '/rtls/ble',
  },
  idCard: {
    title: 'IDカード',
    desc: 'IDカード（社員証）は、社員の身元確認および入退室管理に用いられ、耐久性の高いプラスチックカードにBLEチップを搭載し、非接触で迅速かつ安全な認証を実現します。',
    img: idCard,
    link: '/rtls/ble',
  },
};
